/**
 * Helpers pour interpréter l'erreur du trigger DB `prevent_reservation_physical_overlap`.
 * Le trigger lève une exception Postgres dont le message commence par `PHYSICAL_TABLE_OVERLAP:`.
 */

const OVERLAP_MARKER = "PHYSICAL_TABLE_OVERLAP";

export function isPhysicalOverlapError(error: unknown): boolean {
  if (!error) return false;
  const msg =
    (error as { message?: string })?.message ??
    (typeof error === "string" ? error : "");
  const details = (error as { details?: string })?.details ?? "";
  const hint = (error as { hint?: string })?.hint ?? "";
  return (
    msg.includes(OVERLAP_MARKER) ||
    details.includes(OVERLAP_MARKER) ||
    hint.includes(OVERLAP_MARKER)
  );
}

export function getConflictToastMessage(): {
  title: string;
  description: string;
} {
  return {
    title: "Table déjà occupée",
    description:
      "Cette table (ou l'une des tables d'une combinaison) est déjà prise sur ce créneau. Utilisez « Échanger » pour swapper les deux réservations, ou choisissez une autre table.",
  };
}
